import { mapState, mapActions} from "pinia";
import {defaultCountry, defaultPhoneCode} from "../entities/default";
import moment from "moment/moment";
import useModuleStore from "../stores";


export default {
    data (){
        return {
            PRINCIPAL_RULES:{
                LEVEL_PRINCIPAL: 'P',
                LEVEL_APPLICATION: 'A',
                CRITERIA_ALL_MANDATORY_ROLE: 'AM',
                CRITERIA_ONE_OF_MANDATORY_ROLE: 'OM',
                CRITERIA_EQ: 'EQ',  //equal
                CRITERIA_GT: 'GT',  //Great Than
                CRITERIA_GE: 'GE',  //Great than or Equal
                CRITERIA_LT: 'LT',  //Less Than
                CRITERIA_LE: 'LE',  //Less than or Equal
            },
            PRINCIPAL_ROLES: {
                AUTHORISED_SIGNER: 'AS',
                BENEFICIAL_OWNER: 'BO',
                RESPONSIBLE_PARTY: 'RP',
                DIRECTOR: 'D',
            },
            PRINCIPAL_VALIDATION_TYPE: {
                DOCUMENT: 'DOCUMENT',
                BANK_ID: 'BANK_ID',
            },
            DIRECTIONAL_OWNERSHIP_TYPE: {
                DIRECT_OWNERSHIP: 'DIRECT_OWNERSHIP',
                INDIRECT_OWNERSHIP: 'INDIRECT_OWNERSHIP',
            },
        }
    },
    computed: {
        ...mapState(useModuleStore,{user:'user'}),
        principalRoleToOwnerFieldMap: function() {
            let vm = this;
            return {
                [vm.PRINCIPAL_ROLES.AUTHORISED_SIGNER]: 'is_signatory',
                [vm.PRINCIPAL_ROLES.BENEFICIAL_OWNER]: 'is_beneficial_owner',
                [vm.PRINCIPAL_ROLES.RESPONSIBLE_PARTY]: 'is_responsible_party',
                [vm.PRINCIPAL_ROLES.DIRECTOR]: 'is_director',
            };
        },
        criiptoAcrValues: function (){
            if (!this.canUseBankIdVerify){
                return []
            }

            if(this.parameters.hasOwnProperty('BANK_ID_VERIFICATION_ACR_VALUES') && this.parameters.BANK_ID_VERIFICATION_ACR_VALUES) {
                return  Object.values(this.parameters.BANK_ID_VERIFICATION_ACR_VALUES);
            }
            return [];
        },
    },
    methods: {
        resetAccordionIcon: function (){
            // toggling all owners icons' flags to false
            if (!!this.owners && this.owners.length > 0){
                this.owners.forEach(obj => obj.is_open = false);
            }
        },
        toggleAccordionSection: function  (block){
            block.is_open = !block.is_open
        },
        showAccordion: function (index){
            let $accordion = `#collapse_${index}`;
            let $principal_card  = `#director_${index}`;
            $($accordion).collapse('show');
            if (index !== 0){
                $('html, body').animate({
                    scrollTop: $($principal_card).offset().top
                }, 1000);
            }

            if (!!this.owners && this.owners.length > 0) {
                this.toggleAccordionSection(this.owners[index]);
            }
        },
        getRolesByRuleLevelAndCriteria: function(principal_logic_configs, rule_level, rule_criteria) {
            let roles = [];
            if (!(Array.isArray(principal_logic_configs))) {
                //console.log('Error!', principal_logic_configs);
                return roles;
            }
            principal_logic_configs.forEach(rule => {
                if (rule.rule_level === rule_level && rule.rule_criteria === rule_criteria) {
                    roles.push(rule.principal_role);
                }
            });
            return roles;
        },
        getOwnershipPercentRule: function(principal_logic_configs, rule_level) {
            let vm = this;
            let matched_percentage_rules = [];
            let matched_percentage_rule = {};
            let valid_percentage_criteria = [
                vm.PRINCIPAL_RULES.CRITERIA_EQ,
                vm.PRINCIPAL_RULES.CRITERIA_GT,
                vm.PRINCIPAL_RULES.CRITERIA_GE,
                vm.PRINCIPAL_RULES.CRITERIA_LT,
                vm.PRINCIPAL_RULES.CRITERIA_LE,
            ];
            if (!(Array.isArray(principal_logic_configs))) {
                //console.log('Error!', principal_logic_configs);
                return [];
            }
            principal_logic_configs.forEach(rule => {
                let is_percentage = valid_percentage_criteria.includes(rule.rule_criteria);
                if (is_percentage && rule.rule_level === rule_level) {
                    matched_percentage_rule['principal_role'] = rule.principal_role;
                    matched_percentage_rule['rule_criteria'] = rule.rule_criteria;
                    matched_percentage_rule['ownership_percentage'] = rule.ownership_percentage;
                    matched_percentage_rules.push(matched_percentage_rule);
                }
            });
            return matched_percentage_rules;
        },
        getOwnerFieldByRole: function(principal_role) {
            let vm = this;
            if (vm.principalRoleToOwnerFieldMap && vm.principalRoleToOwnerFieldMap.hasOwnProperty(principal_role)) {
                return vm.principalRoleToOwnerFieldMap[principal_role];
            }
            //console.log('Error! Invalid role: ', principal_role, ' to search in ', vm.principalRoleToOwnerFieldMap);
            return null;
        },
        getTranslationForPrincipalRoles: function(principal_roles) {
            let vm = this;
            let translation_texts = [];
            let role_to_translation_key_Map = {
                [vm.PRINCIPAL_ROLES.AUTHORISED_SIGNER] : 'signatory',
                [vm.PRINCIPAL_ROLES.BENEFICIAL_OWNER]: 'beneficial_owner',
                [vm.PRINCIPAL_ROLES.RESPONSIBLE_PARTY]: 'responsible_party',
                [vm.PRINCIPAL_ROLES.DIRECTOR]: 'director',
            };

            if (!Array.isArray(principal_roles)) {
                principal_roles = [principal_roles];
            }

            principal_roles.forEach(principal_role => {
                if (Object.keys(role_to_translation_key_Map).includes(principal_role)) {
                    let translation_key = role_to_translation_key_Map[principal_role];
                    translation_texts.push(vm.lang(translation_key));
                }
            });

            return translation_texts.join(', ');
        },
        isBankIdValidationOwner: function (owner) {
            return owner && owner.hasOwnProperty('verification_type') && !!owner.verification_type
                && (owner.verification_type !== this.PRINCIPAL_VALIDATION_TYPE.DOCUMENT);
        },
        disabledShareholderFields: function (owner) {
            if (this.isBankIdValidationOwner(owner)) {
                return ['owner_first_name', 'owner_surname', 'contact_dob'];
            }
            return [];
        },
        processPersonnelSearchData: function (data, personnelObject = {}) {
            const shareholder = Object.assign(data.shareholder, data.shareholder.details);
            let principal = this.owners[this.current_index], vm = this, principal_keys =[];

            let keyMap = {
                owner_title: 'title',
                owner_first_name: 'first_name',
                owner_second_name: 'middle_name',
                owner_surname: 'last_name',
                contact_dob: 'date_of_birth',
                owner_nationality: 'nationality',
                // owner_position: 'position',
                ownership_perc: 'percentage_of_shares',
                email_address: '',
                // owner_alt_phone_no: '',
                // owner_alt_phone_code: defaultPhoneCode,
                owner_phone_no: '',
                owner_phone_code: defaultPhoneCode,
                zip_code: 'address',
                house_name: '',
                house_number: '',
                flat_name: '',
                flat_number: '',
                street_line_1: '',
                locality: '',
                city: '',
                county_code: '',
                // country_code: defaultCountry
            };

            Object.keys(keyMap).forEach(d => {
                if (vm.disabledShareholderFields(principal).includes(d)) {
                    return;
                }

                if (keyMap[d] !== '' && shareholder.hasOwnProperty(keyMap[d])) {

                    if (d === 'zip_code') {
                        principal.contacts[0][d] = shareholder[keyMap[d]]['postcode'];

                        //ask user to search postcode
                        principal.contacts[0]['street_line_1'] = '';
                        principal.contacts[0]['search_postcode'] = true;
                        // this.updateCompanyAddress(data.address, personnelObject.contacts[0]);
                        // let country_iso2 = !!shareholder[keyMap[d]]['country_code'] ? shareholder[keyMap[d]]['country_code'] : '';
                        // let country_code = vm.getCountryNumCodeFromIso2(country_iso2);
                        // principal['country_code'] = country_code;
                        let zip_code = !!shareholder[keyMap[d]]['postcode'] ? shareholder[keyMap[d]]['postcode'] : '';
                        // principal['zip_code'] = zip_code;
                        if (!!zip_code) {
                            let postcodeElement = vm.$refs['zip_code'][vm.current_index];
                            postcodeElement.search(zip_code);
                        }
                        // else {
                        //     let street = !!shareholder[keyMap[d]]['address_line1'] ? shareholder[keyMap[d]]['address_line1'] : '',
                        //         county_code = !!shareholder[keyMap[d]]['county'] ? shareholder[keyMap[d]]['county'] : '',
                        //         city = !!shareholder[keyMap[d]]['city'] ? shareholder[keyMap[d]]['city'] : ''
                        //     principal['county_code'] = county_code;
                        //     principal['city'] = city;
                        //     principal['street_line_1'] = street;
                        //
                        // }
                    } else if (d === 'contact_dob') {
                        let contact_dob = (!!shareholder[keyMap[d]] ? shareholder[keyMap[d]] : '');
                        // let contact_dob = (!!shareholder[keyMap[d]] ? shareholder[keyMap[d]] : '').split('-');
                        // let dob = `01-${contact_dob[1]}-${contact_dob[0]}`;
                        const date_format_mapping = {
                            ddmmyyyy: 'DD-MM-YYYY',
                            mmddyyyy: 'MM-DD-YYYY',
                            yyyymmdd: 'YYYY-MM-DD'
                        }

                        const tenant_format = $('body').attr('data-date-format')
                        const parsedDate = moment(contact_dob, date_format_mapping['ddmmyyyy']);
                        const formatted_contact_dob = parsedDate.format(date_format_mapping[tenant_format]);

                        principal[d] = formatted_contact_dob;
                    } else if (d === 'owner_title') {
                        let value = shareholder[keyMap[d]] !== '' ? `${shareholder[keyMap[d]]}.` : '';

                        if (value !== '') {
                            let title = this.primeTitles.find(obj => {
                                return obj.id === value
                            });

                            //check if the value is part of the prime titles in the radios.
                            if (!title) {
                                //principal[d] = 'other';
                                //principal['other_owner_title'] = value;
                            } else {
                                principal[d] = `${shareholder[keyMap[d]]}.`;
                            }
                        }

                    } else if (d === 'owner_nationality') {
                        let country_iso2 = !!shareholder[keyMap[d]] ? shareholder[keyMap[d]] : 'GB';
                        // //console.log(country_iso2)
                        let country_code = vm.getCountryNumCodeFromNationality(country_iso2);
                        principal[d] = country_code;
                    } else if (d === 'owner_first_name') {
                        let first_name = shareholder[keyMap[d]].split(" ");
                        if (first_name.length > 0) {
                            principal[d] = first_name[0];
                        }
                    } else {
                        principal[d] = shareholder[keyMap[d]];
                    }
                } else if (d === 'owner_second_name') {
                    if (!!shareholder[keyMap['owner_first_name']] && !shareholder[keyMap[d]]) {
                        let middle_name = this.getMiddleName(shareholder[keyMap['owner_first_name']]);
                        principal[d] = !!middle_name ? middle_name : '';
                    }
                } else {
                    if (d === 'owner_phone_code' || d === 'owner_alt_phone_code') {
                        principal[d] = defaultPhoneCode;
                    }
                    else if (d === 'owner_nationality') {
                        principal[d] = defaultCountry;
                    }
                    else if (d === 'ownership_perc') {
                        if (vm.merchant && (vm.merchant.ownership_entity_type === vm.business_types.SOLE_TRADER)) {
                            //skip
                        }
                    }
                    else if (d === 'owner_second_name') {
                        if (!!shareholder[keyMap['owner_first_name']] && !shareholder[keyMap[d]]) {
                            let middle_name = this.getMiddleName(shareholder[keyMap['owner_first_name']]);
                            principal[d] = !!middle_name ? middle_name : '';
                        }
                    }
                    else {
                        principal[d] = '';
                    }
                }

                //get the fields for the validation
                principal_keys.push(d + '_'+ this.current_index)
            });
            // this.runValidationOnFieldChange(principal_keys)
        },
        getMiddleName: function (owner_first_name) {
            let middle_name = '';
            if (!!owner_first_name) {
                let splitted_fname_array = owner_first_name.split(/ (.*)/,2);
                if (splitted_fname_array.length > 0) {
                    middle_name = splitted_fname_array[1];
                }
            }
            return middle_name;
        },
    }

};